import { Table, Text, Title } from '@mantine/core';
import moment from 'moment';
import { default as React } from 'react';
import { useAuth } from '../../contexts/auth.context';

export default function VehicleTrajectView({ data }){
    const { currentCompany } = useAuth();

    if(!data?.data) return;
    return <>
        {(data.data ?? []).map(d => <div style={{pageBreakBefore: 'always', padding: '2cm'}}>
            <Title ta="center" order={2}>Relatório de distância percorrida - {getPeriodText(data)}</Title>
            <Title ta="center" order={3} fw="normal">{currentCompany?.company?.name}</Title>

            <Title mt="xl" order={4}>VEÍCULO: {d.vehicle.license_plate} - {[d.vehicle.brand, d.vehicle.model].filter(nn => nn).join(" / ")}</Title>
            <div style={{fontSize: 13, margin: '20px 0'}}>
                <div>
                    <Table
                        mt="xl"
                        striped
                    >
                        <thead>
                            <tr>
                                <th style={{textAlign: 'center'}}>Data</th>
                                {(data?.props?.periods ?? []).map((period, i) => (
                                    <th style={{textAlign: 'center'}}>{period.name ?? `Intervalo ${i+1}`}</th>
                                ))}
                                <th style={{textAlign: 'center'}}>Somatório</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            (d.dates ?? [])
                            .filter(d => d.periods.some(p => p.distance > 0))
                            .sort((a,b) => a.date > b.date ? 1 : -1)
                            .map(date => <>
                                <tr>
                                    <td style={{textAlign: 'center'}}><Text c="black">{moment(date.date).format("DD/MM/YYYY")}</Text></td>
                                    {(date.periods ?? []).map((period, i) => (
                                        <td style={{textAlign: 'center'}}>
                                            <Text size="xs" c="gray">{({...{...data?.props?.vehicles}[date.date]}[d.vehicle._id] ?? [])[i]?.start} à {({...{...data?.props?.vehicles}[date.date]}[d.vehicle._id] ?? [])[i]?.finish}</Text>
                                            <Text size="md">{(period.distance ?? 0).toFixed(0)}</Text>
                                        </td>
                                    ))}
                                    <td style={{textAlign: 'center'}}>
                                        <Text size="xs" c="gray">Total</Text>
                                        <Text size="md">{date.periods.reduce((pv,item) => pv+item.distance, 0).toFixed(0)}</Text>
                                    </td>
                                </tr>
                            </>)
                        }
                        </tbody>
                        <tfoot>
                            <tr>
                                <th style={{textAlign: 'center'}}>TOTAL</th>
                                {
                                    (data?.props?.periods ?? []).map((period, i) => (
                                        <th style={{textAlign: 'center'}}>
                                            <Text size="md">
                                                {d.dates.reduce((pv, dt) => pv + ((dt.periods[i] && dt.periods[i].distance > 0) ? dt.periods[i].distance : 0), 0).toFixed(0)}
                                            </Text>
                                        </th>
                                    ))
                                }
                                <th style={{textAlign: 'center'}}>
                                    <Text size="md">
                                    {(
                                        (data?.props?.periods ?? [])
                                        
                                        .map((p, i) => d.dates.reduce((pv, dt) => pv + ((dt.periods[i] && dt.periods[i].distance > 0) ? dt.periods[i].distance : 0), 0), 0)
                                        .reduce((pv, v) => pv+v, 0)
                                    ).toFixed(0)}
                                    </Text>
                                </th>
                            </tr>
                        </tfoot>
                    </Table>
                </div>
            </div>
            <div style={{marginTop: 40}}>
                <Text size="xs" color="gray" style={{flex: 1}}>Relatório facilitado por satify.com.br</Text>
                <Text size="xs" color="gray" style={{flex: 1}} ta="right">Data da emissão: {moment(data?.createdAt).format("DD/MM/YYYY HH:mm")}</Text>
            </div>
        </div>)}
    </>
}

const getPeriodText = ({ data = [] } : { data: any[] }) => {
    let start;
    let finish;

    for(let d of data){
        for(let { date } of d.dates ?? []){
            if(!start || date < start) start = date;
            if(!finish || date > finish) finish = date;
        }
    }

    return [ start, finish ].filter(nn => nn).map(d => moment(d).format("DD/MM/YYYY")).join(" à ")
}